import EmbedModes from "../../../../src/pages/apis/pdf-embed/embed-modes.md";
import Annotations from "../../../../src/pages/apis/pdf-embed/annotations.md";
import PDFAnalytics from "../../../../src/pages/apis/pdf-embed/pdf-Analytics";
import Collaborative from "../../../../src/pages/apis/pdf-embed/collaborative-settings.md";
import SaveControls from "../../../../src/pages/apis/pdf-embed/save-controls.md";
import MenuTool from "../../../../src/pages/apis/pdf-embed/menu-tool-options";
import UseCase from "../../../../src/pages/apis/pdf-embed/use-case.md";
import StartEmbedding from "../../../../src/pages/apis/pdf-embed/start-embedding.md";
import WhyPdfEmbed from "../../../../src/pages/apis/pdf-embed/why-pdf-embed.md";
import KeyFeatures from "../../../../src/pages/apis/pdf-embed/key-features.md";
import ExploreAdobe from "../../../../src/pages/apis/pdf-embed/explore-adobe.md";
import Integration from "../../../../src/pages/apis/pdf-embed/integration.md";
import { APIPixelRetargeting } from "../../../../src/components/retargetting";
import { NewsLetterBlade } from "../../../../src/components/news-letter-blade";
import * as React from 'react';
export default {
  EmbedModes,
  Annotations,
  PDFAnalytics,
  Collaborative,
  SaveControls,
  MenuTool,
  UseCase,
  StartEmbedding,
  WhyPdfEmbed,
  KeyFeatures,
  ExploreAdobe,
  Integration,
  APIPixelRetargeting,
  NewsLetterBlade,
  React
};